import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface ModuleCountState {
  counts: Record<string, number>;
}

const initialState: ModuleCountState = {
  counts: {},
};

const adminModuleCountSlice = createSlice({
  name: 'moduleCounts',
  initialState,
  reducers: {
    setModulewiseCount: (state, action: PayloadAction<{ key: string; value: number }>) => {
      state.counts[action.payload.key] = action.payload.value;
    },
    resetCounts: (state) => {
      state.counts = {};
    },
  },
});

export const { setModulewiseCount, resetCounts } = adminModuleCountSlice.actions;
export default adminModuleCountSlice.reducer;
